var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterwaveLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 620,
    viewBox: "0 0 132 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0773 607.351C63.411 556.521 141.601 413.463 75.6894 247.874C45.9977 166.668 6.92523 -5.61649 88.1693 -45.1029",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01282 608.374C54.7733 557.574 133.627 414.563 66.959 248.921C36.9217 167.69 -2.65062 -4.62942 79.3588 -44.0618",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.23524 605.299C46.0985 554.469 124.288 411.411 58.3769 245.822C28.6852 164.616 -10.3873 -7.66825 70.8568 -47.1547",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.1278 603.84C37.6327 553.04 116.487 410.029 49.8183 244.386C19.781 163.156 -19.7912 -9.1636 62.2182 -48.596",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.7235 605.726C28.6102 554.896 106.8 411.838 40.8886 246.249C11.1969 165.043 -27.8756 -7.24149 53.3685 -46.7279",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.9306 604.316C20.4032 553.486 98.5929 410.428 32.6816 244.839C2.98988 163.632 -36.0826 -8.65165 45.1615 -48.1381",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.2684 604.56C12.0653 553.73 90.255 410.672 24.3437 245.083C-5.34801 163.877 -44.4205 -8.40751 36.8236 -47.8939",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.536 603.976C3.79773 553.146 81.9874 410.088 16.0761 244.499C-13.6156 163.293 -52.6881 -8.99149 28.556 -48.4779",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.8095 603.392C-4.47571 552.562 73.714 409.504 7.80271 243.915C-21.889 162.709 -60.9615 -9.57548 20.2825 -49.0619",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.4071 607.121C-14.0734 556.29 64.1163 413.232 -1.79494 247.643C-31.4867 166.437 -70.5591 -5.84696 10.6849 -45.3334",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.4735 608.14C-22.713 557.34 56.1409 414.329 -10.5274 248.686C-40.5647 167.456 -80.1369 -4.86379 1.87246 -44.2962",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78.7157 605.065C-31.382 554.235 46.8077 411.177 -19.1035 245.588C-48.7953 164.382 -87.8677 -7.90263 -6.6237 -47.3891",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87.6122 603.608C-39.8517 552.807 39.0023 409.796 -27.666 244.154C-57.7033 162.923 -97.2756 -9.39602 -15.2662 -48.8284",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.202 605.495C-48.8683 554.664 29.3214 411.606 -36.5899 246.017C-66.2816 164.811 -105.354 -7.47294 -24.11 -46.9594",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.419 604.084C-57.0851 553.253 21.1046 410.195 -44.8067 244.606C-74.4984 163.4 -113.571 -8.88407 -32.3268 -48.3705",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.749 604.326C-65.4152 553.495 12.7745 410.437 -53.1367 244.849C-82.8285 163.642 -121.901 -8.64188 -40.6569 -48.1283",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.02 603.743C-73.6866 552.912 4.50305 409.854 -61.4082 244.266C-91.1 163.059 -130.172 -9.22489 -48.9284 -48.7113",
    stroke: "white",
    strokeWidth: 0.829217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.29 603.159C-81.9562 552.328 -3.76649 409.27 -69.6778 243.682C-99.3695 162.475 -138.442 -9.80888 -57.1979 -49.2953",
    stroke: "white",
    strokeWidth: 0.829217
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterwaveLines);
export default __webpack_public_path__ + "static/media/footerwaveLines.d1b2f3be30bdd8e3e2badfa74c0dbffd.svg";
export { ForwardRef as ReactComponent };